/*
 * ApplicationDetailsClusterCompatibity.jsx
 * Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
 * All rights reserved.
 */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClusterDetails } from "../../Services/redux/ClusterCompatibility/ClusterCompatibilityActions";
import { Grid2, Container, Typography, Checkbox, Button } from "@mui/material";
import PropTypes from "prop-types";
import "./ApplicationDetailsClusterCompatibity.css";
import { getConfig } from "../../config";

function ApplicationDetailsClusterCompatibity({ postCallTheNewSubmission }) {
  const dispatch = useDispatch();
  const [checkedClusters, setCheckedClusters] = useState([]);
  const [clusters, setClusters] = useState([]);
  const clusterDetails = useSelector(
    (state) => state.clusterDetails.clusterDetails
  );
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "seller")
      dispatch(fetchClusterDetails());
  }, []);

  useEffect(() => {
    if (
      submissionData &&
      Object.keys(submissionData).length > 0 &&
      clusterDetails &&
      Object.keys(clusterDetails).length > 0 &&
      clusterDetails.clusterNumbers &&
      clusterDetails.clusterNumbers.length > 0
    ) {
      setClusters([...clusterDetails.clusterNumbers]);
      if (
        submissionData.clusterNumber &&
        submissionData.clusterNumber.length > 0
      ) {
        setCheckedClusters([...submissionData.clusterNumber]);
      }
    }
  }, [dispatch, submissionData, clusterDetails]);

  const handleCheckedItems = ($event) => {
    const item = $event.target.name;
    const checked = $event.target.checked;
    if (checked) {
      setCheckedClusters([...checkedClusters, item]);
    } else {
      const filter = checkedClusters.filter((cluster) => cluster !== item);
      setCheckedClusters([...filter]);
    }
  };

  const saveTheClusters = () => {
    let newSubmissionData = { ...submissionData };
    newSubmissionData.clusterNumber = [...checkedClusters];
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start" alignItems="center">
        <Grid2
          size={12}
          sx={{
            display: "flex !important",
            "justify-content": "center !important",
          }}
        >
          <div
            className={
              getConfig().REACT_APP_PORTAL === "seller"
                ? "cluster-copatibility"
                : "cluster-copatibility fullwidth"
            }
            id="cluster-section"
            style={
              submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.status !== "DRAFT"
                ? {
                    marginTop: "30px",
                    borderBottom: "1px solid rgba(18, 20, 21, 0.2)",
                  }
                : { marginTop: "0px", borderBottom: "0px" }
            }
          >
            <div
              className="text-button-row"
              style={
                submissionData &&
                Object.keys(submissionData).length > 0 &&
                submissionData.status === "DRAFT"
                  ? { width: "94%" }
                  : { width: "100%" }
              }
            >
              <Typography
                sx={{
                  "font-weight": "bold !important",
                  "font-size": "20px !important",
                  // "letter-spacing": "0.4px !important",
                  color: "rgba(18, 20, 21, 1) !important",
                  marginBottom: "10px",
                }}
                className="uploadSignedApkText"
              >
                Cluster Compatibility
              </Typography>
              {submissionData.status === "DRAFT" &&
                getConfig().REACT_APP_PORTAL === "seller" && (
                  <Button
                    sx={{
                      border: "1px solid  #0476E2",
                      "font-weight": "400px !important",
                      color: "#0476E2 !important",
                      "font-size": "12px !important",
                      // "letter-spacing": "0.4px !important",
                      "line-height": "19.6px",
                    }}
                    onClick={saveTheClusters}
                  >
                    Set
                  </Button>
                )}
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginTop:
                  submissionData &&
                  Object.keys(submissionData).length > 0 &&
                  submissionData.status === "DRAFT"
                    ? "20px"
                    : "0px",
                marginBottom: "12px",
              }}
            >
              <div style={{ display: "contents" }}>
                {getConfig().REACT_APP_PORTAL === "seller" &&
                clusters &&
                clusters.length > 0
                  ? clusters.map((item) => {
                        return (
                          <div
                            className="cluster-data"
                            style={
                              checkedClusters.includes(item)
                                ? { backgroundColor: "#E5F3FF" }
                                : { backgroundColor: " #FFFFFF" }
                            }
                            key={item}
                          >
                          <div
                            style={{ width: "calc(10%-10px)" }}
                            className="clusters"
                          >
                            <Checkbox
                              checked={checkedClusters.includes(item)}
                              name={item}
                              disabled={
                                submissionData.status !== "DRAFT"
                              }
                              onChange={($event) => handleCheckedItems($event)}
                            />
                            <p
                              className="cluster-item-data"
                              style={
                                checkedClusters.includes(item)
                                  ? { color: "#0476E2", fontWeight: "bold" }
                                  : {}
                              }
                            >
                              CL {item}
                            </p>
                          </div>
                        </div>
                      );
                    })
                  : (getConfig().REACT_APP_PORTAL === "oem-admin" ||
                      (getConfig().REACT_APP_PORTAL === "domain-approver" &&
                        !submissionData.isOemApp)) &&
                    submissionData.clusterNumber &&
                    submissionData.clusterNumber.length > 0 &&
                    submissionData.clusterNumber.map((item) => {
                      return (
                        <div
                          className="cluster-data"
                          style={{ backgroundColor: "#E5F3FF" }}
                          key={item}
                        >
                          <div
                            style={{ width: "calc(10%-10px)" }}
                            className="clusters"
                          >
                            <Checkbox
                              checked={true}
                              name={item}
                              disabled={true}
                            />
                            <p
                              className="cluster-item-data"
                              style={{ color: "#0476E2", fontWeight: "bold" }}
                            >
                              CL {item}
                            </p>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </Grid2>
      </Grid2>
    </Container>  
  );
}

ApplicationDetailsClusterCompatibity.propTypes = {
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default ApplicationDetailsClusterCompatibity;
